module.exports = __webpack_public_path__ + "media/images/front/logo_footer-b61545e53d406503b535ee4d1bfbafe0.png";